import { render, staticRenderFns } from "./VxCardMod.vue?vue&type=template&id=41ae1cb9&"
import script from "./VxCardMod.vue?vue&type=script&lang=js&"
export * from "./VxCardMod.vue?vue&type=script&lang=js&"
import style0 from "./VxCardMod.vue?vue&type=style&index=0&id=41ae1cb9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports